import { AuthSurface } from 'components/ui';
import { getZoomAdjustedCssValue } from 'components/ui/utilities/zoom';
import { useZoom } from 'context/ZoomContext';
import { AuthFooterLinks } from 'pages/Auth/components';
import { PrismThemeProvider } from 'theme';
import { AuthLayoutProps } from './AuthLayout.props';
import { AuthLayoutContent, AuthLayoutFormSlot, AuthLayoutRoot } from './AuthLayout.styles';

const AuthLayout = ({ children }: AuthLayoutProps) => {
  const { zoomLevel } = useZoom();

  return (
    <PrismThemeProvider>
      <AuthLayoutRoot
        sx={{
          minHeight: getZoomAdjustedCssValue('100vh', zoomLevel),
          width: getZoomAdjustedCssValue('100vw', zoomLevel),
          '@supports (min-height: 100dvh)': {
            minHeight: getZoomAdjustedCssValue('100dvh', zoomLevel),
          },
          '@supports (width: 100dvw)': {
            width: getZoomAdjustedCssValue('100dvw', zoomLevel),
          },
        }}
      >
        <AuthLayoutContent>
          <AuthLayoutFormSlot>
            <AuthSurface>{children}</AuthSurface>
          </AuthLayoutFormSlot>
          <AuthFooterLinks />
        </AuthLayoutContent>
      </AuthLayoutRoot>
    </PrismThemeProvider>
  );
};

export default AuthLayout;
